import api from "../../config/client.axios.api";

export const getFrameAnalysticApiRequest = async ({
  accountId,
  startDate,
  endDate,
}: any) => {
  const response = await api.get(
    `/frame/analystic-by-store?startDate=${startDate}&endDate=${endDate}&idAccount=${accountId}`
  );
  return response.data;
};
